import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import { IECSummaryHeader } from "../components/HeaderAttribute";
import * as XLSX from "sheetjs-style";
import jsPDF from "jspdf";
import "jspdf-autotable";
import fpaiLogo from "../image/FPAILogo.jpg";
import MultiSelect from "../ReusableComponents/MultiSelect";
import { useUserCapability } from "../components/ConstantReducerProvider";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Loader from "../ReusableComponents/Loader";

const ReportIECSummary = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [branchProject, setBranchProject] = useState("");
  const [branchName, setBranchName] = useState("");
  const [sdp, setSDP] = useState("");
  const [branchProjectError, setBranchProjectError] = useState("");
  const [sdpError, setSDPError] = useState("");
  const [area, setArea] = useState("");
  const [areaError, setAreaError] = useState("");
  const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
  const [bindIECSummaryData, setBindIECSummaryData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [fromDateError, setFromDateError] = useState("");
  const [toDate, setToDate] = useState("");
  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);
  const [bindMonthDD, setBindMonthDD] = useState([]);
  const [fromMonth, setFromMonth] = useState("");
  const [fromMonthError, setFromMonthError] = useState("");
  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);
  const [sdpNamesList, setSDPNamesList] = useState([]);
  const [areaNamesList, setAreaNamesList] = useState([]);
  const [year, setYear] = useState("");
  const [yearError, setYearError] = useState("");
  const [bindYearDD, setBindYearDD] = useState([]);

  useEffect(
    () => {
      if (branchProject) {
        try {
          const getSelectedSDP = async () => {
            const userProfileDatas = userProfileState.userProfile;
            const [profile] = userProfileDatas;
            const data = {
              mstOrganizationStructureId: profile.MstOrganizationId,
              mstBranchId: profile.MstLocationId,
              mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
              mstUserId: profile.MstUserId,
              mstRoleId: profile.MstRoleId,
              languageCode: "en",
            };


            const locationResponse = await BindPostAPI([data], "SDPAPI/GetSDP");
            setGetSDPDatas(locationResponse.data.Table);

            if (userProfileDatas && userProfileDatas[0]) {
              const sdpLabels = locationResponse.data.Table.filter((item) =>
                branchProject.includes(parseInt(item.MstLocationId)),
              ).map((item) => ({
                MstSDPId: item.MstSDPId,
                SDP_en: item.SDP_en,
              }));

              const sdpSelected = sdpLabels.map((SD) => ({
                value: SD.MstSDPId,
                label: SD.SDP_en,
              }));

              if (
                userProfileDatas[0].MstOrganizationId == 1 ||
                userProfileDatas[0].MstOrganizationId == 2
              ) {
                setBindSDP(sdpSelected);
              } else {
                const allSDPIds = userProfileDatas[0]?.AllSDP;
                const sdpId = userProfileDatas[0]?.MstSDPId;

                if (allSDPIds && Array.isArray(allSDPIds)) {
                  const filteredSdpSelected = sdpSelected.filter((sdp) =>
                    allSDPIds.includes(sdp.value),
                  );
                  setBindSDP(filteredSdpSelected);
                }
                if (sdpId) {
                  setBindSDP([]);
                  const filteredSdpSelected = sdpSelected.filter((sdp) =>
                    Array.isArray(sdpId)
                      ? sdpId.includes(sdp.value)
                      : sdpId === sdp.value,
                  );
                  setBindSDP(filteredSdpSelected);
                }
              }
            }
          };

          getSelectedSDP();
        } catch (e) { }
      }
    },
    [branchProject ? branchProject : undefined],
    userProfileDatas ? userProfileDatas : undefined,
  );
  useEffect(() => {
    if (sdp) {
      try {
        const getSelectedArea = async () => {
          const userProfileDatas = userProfileState.userProfile;
          const [profile] = userProfileDatas;
          const data = {
            mstOrganizationStructureId: profile.MstOrganizationId,
            mstBranchId: profile.MstLocationId,
            mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
            mstUserId: profile.MstUserId,
            mstRoleId: profile.MstRoleId,
            languageCode: "en",
          };


          const locationResponse = await BindPostAPI([data], "AreaAPI/GetArea");
          setGetAreaDatas(locationResponse.data.Table);

          const areaLabels = locationResponse.data.Table.filter((item) =>
            sdp.includes(item.MstSDPId),
          ).map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

          const areaSelected = areaLabels.map((AR) => ({
            value: AR.MstAreaId,
            label: AR.AreaName_en,
          }));

          setBindAreaDD(areaSelected);
        };

        getSelectedArea();
      } catch (e) { }
    }
  }, [sdp ? sdp : undefined]);

  useEffect(() => {
    if (
      userProfileDatas[0]?.MstOrganizationId == 2 ||
      userProfileDatas[0]?.MstOrganizationId == 3
    ) {
      if (userProfileDatas[0]?.MstSDPId == null) {
        setBranchName(userProfileDatas[0]?.LocationName_en);
        setBranchProject([userProfileDatas[0]?.MstLocationId]);
        setSDP("");
      } else {
        setBranchName(userProfileDatas[0]?.LocationName_en);
        setBranchProject([userProfileDatas[0]?.MstLocationId]);
        setSDP([userProfileDatas[0]?.MstSDPId]);
      }
    }
    BranchProjectFetchData();
  }, [userProfileDatas ? userProfileDatas : undefined]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearsArray = Array.from(
      { length: 70 },
      (_, index) => currentYear - index,
    );
    let yearDropdown = yearsArray.map((year) => ({
      label: year.toString(),
      value: year,
    }));
    setBindYearDD(yearDropdown);
  }, []);

  const getMonthDDValues = async () => {
    // Month Dropdown binding
    const response = await BindAPI("MasterDataAPI/BindMonth");
    const getTnxMonthId =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
          value: item.TxnMonthId,
          label: item.MonthName,
        }))
        : [];
    setBindMonthDD(getTnxMonthId);
  };

  const GoButton = async () => {
    setIsLoading(true);
    const fromYearValidate = year ? "" : "Select Year";
    setYearError(fromYearValidate);
    const branchProjectValidate = branchProject ? "" : "Select Branch/Project";
    setBranchProjectError(branchProjectValidate);

    const sdpValidate = sdp ? "" : "Select SDP";
    setSDPError(sdpValidate);

    const areaValidate = area ? "" : "Select Area";
    setAreaError(areaValidate);
    const fromMonthValidate = fromDate ? "" : "Select Month";
    setFromDateError(fromMonthValidate);
    let branchArray = Array.from(
      { length: branchProject.length },
      (v, i) => branchProject[i],
    );
    let branchResult = branchArray.join(",");

    let sdpArray = Array.from({ length: sdp.length }, (v, i) => sdp[i]);
    let sdpResult = sdpArray.join(",");

    let areaArray = Array.from({ length: area.length }, (v, i) => area[i]);
    let areaResult = areaArray.join(",");

    if (
      !branchProjectValidate &&
      !sdpValidate &&
      !areaValidate &&
      !fromMonthValidate &&
      !fromYearValidate
    ) {
      const currentYear = new Date().getFullYear();

      const fromMonthDate = fromDate
        ? `${year}-${String(fromDate).padStart(2, "0")}-01`
        : "";

      const toMonthDate = fromDate
        ? new Date(year, fromDate, 0).toISOString().split("T")[0]
        : "";
      //    const fromMonthDate = fromMonth
      //    ? `${year}-${String(fromMonth).padStart(2, "0")}-01`
      //    : "";

      //  // Last day of the month
      //  const toMonthDate = fromMonth
      //    ? new Date(year, fromMonth, 0).toISOString().split("T")[0]
      //    : "";

      // First day of the month
      // const fromMonthDate = fromDate
      //   ? `${currentYear}-${String(fromDate).padStart(2, "0")}-01`
      //   : "";

      // // Last day of the month
      // const toMonthDate = fromDate
      //   ? new Date(currentYear, fromDate, 0).toISOString().split("T")[0]
      //   : "";
      const ReportData = [
        {
          mstBranchId: branchResult,
          mstSDPId: sdpResult,
          mstAreaId: areaResult,
          fromDate: fromMonthDate,
          toDate: toMonthDate,
        },
      ];

      const response = await BindPostAPI(ReportData, "IECAPI/ReportIECSummary");

      setBindIECSummaryData(response.data.Table);
      setShowTable(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    // const today = new Date();
    // const currentYear = today.getFullYear();
    // const automaticFromDate = `${currentYear}-01-01`;
    // setFromDate(automaticFromDate);

    // const formattedToDate = today.toISOString().split("T")[0];
    // setToDate(formattedToDate);
    getMonthDDValues();
  }, []);
  const createdBy = sessionStorage.getItem("createdBy");
  const handleExport = async () => {
    try {
      const filterData = bindMonthDD.find((item) => item.value === fromDate);

      const filterData1 = bindYearDD.find((item) => item.value === year);

      const dateRange = {
        fromDate: filterData?.label || "",
        toDate: filterData1?.label || "",
      };

      const selectedOptionsData = {
        branchProjectData:
          branchProjectNamesList.length > 0
            ? branchProjectNamesList.toString()
            : branchName,
        sdpData: sdpNamesList.toString(),
        areaData: areaNamesList.toString(),
      };

      // Export Function
      await exportData(
        IECSummaryHeader.map((column) => column.title),
        bindIECSummaryData,
        dateRange,
        selectedOptionsData,
      );

      // ✅ Success Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: `IEC - Summary`,
          action: "Excel Export",
          status: "SUCCESS",
          tableName: null,
          description: `IEC - Summary Excel exported successfully for Month ${filterData?.label}, Year ${filterData1?.label}`,
        },
        "Log/IUDLog",
      );

      console.log("IEC - Summary Excel export completed successfully");
    } catch (error) {
      console.error("IEC - Summary Excel export failed:", error);

      // ❌ Failed Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: `IEC - Summary`,
          action: "Excel Export",
          status: "FAILED",
          tableName: null,
          description: `IEC - Summary Excel export failed - ${error?.message || "Unknown Error"
            }`,
        },
        "Log/IUDLog",
      );
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  const exportData = (columns, rows, dateRange, selectedDetails) => {
    const titleRow = [
      {
        v: "IEC Summary",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    // Date range row with merged cells
    const dateRangeRow = [
      { v: "" },
      {
        v: "Month :",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: dateRange.fromDate,
        s: {
          alignment: { horizontal: "left" },
        },
      },
      {
        v: "Year :",
        s: {
          font: { bold: true },
          alignment: { horizontal: "left" },
        },
      },
      {
        v: dateRange.toDate,
        s: {
          alignment: { horizontal: "left" },
        },
      },
    ];

    // Branch information row with merged cells
    const branchRow = [
      { v: "" },
      {
        v: "Branch/Project:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.branchProjectData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },

      {
        v: "S.D.P.:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.sdpData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },

      {
        v: "Area:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.areaData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },
    ];

    // Add empty row for spacing
    const spacingRow = [{ v: "" }];

    const headerRow1 = [
      {
        v: "S.No.",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "Branch",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "SDP",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "Area",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "Type of topic/ subject",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "Interpersonal contact (1-4 persons)",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      { v: "", s: {} },
      { v: "", s: {} },
      { v: "", s: {} },
      {
        v: "Group discussions (5-20 persons)",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      { v: "", s: {} },

      {
        v: "General / Mass meetings (21+persons)",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      { v: "", s: {} },
      {
        v: "Mass media/Supporting activities",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      { v: "", s: {} },
    ];

    const headerRow2 = [
      { v: "", s: {} },
      { v: "", s: {} },
      { v: "", s: {} },
      { v: "", s: {} },
      { v: "", s: {} },
      {
        v: "Gender/Age",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "10-14 Years",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "15-24 Years",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "25+ Years",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "Events",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "Participants",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "Events",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "Participants.",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },

      {
        v: "Events",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
      {
        v: "Participants",
        s: {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "2D2D6E" } },
        },
      },
    ];

    const columnTotals = {
      tentoYears: 0,
      fifteentoYears: 0,
      twentyfivetoYears: 0,
      GroupDiscussionsEvents: 0,
      GDParticipants: 0,
      GeneralMassEvents: 0,
      GMMParticipants: 0,
      MassMediaEvents: 0,
      MMParticipants: 0,
    };
    // Data rows with row totals
    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      // Calculate row total for numeric fields
      const rowTotal =
        Number(rowData.tentoYears || 0) +
        Number(rowData.fifteentoYears || 0) +
        Number(rowData.twentyfivetoYears || 0) +
        Number(rowData.GroupDiscussionsEvents || 0) +
        Number(rowData.GDParticipants || 0) +
        Number(rowData.GeneralMassEvents || 0) +
        Number(rowData.GMMParticipants || 0) +
        Number(rowData.MassMediaEvents || 0) +
        Number(rowData.MMParticipants || 0);

      // Add to column totals
      columnTotals.tentoYears += Number(rowData.tentoYears || 0);
      columnTotals.fifteentoYears += Number(rowData.fifteentoYears || 0);
      columnTotals.twentyfivetoYears += Number(rowData.twentyfivetoYears || 0);
      columnTotals.GroupDiscussionsEvents += Number(
        rowData.GroupDiscussionsEvents || 0,
      );
      columnTotals.GDParticipants += Number(rowData.GDParticipants || 0);
      columnTotals.GeneralMassEvents += Number(rowData.GeneralMassEvents || 0);
      columnTotals.GMMParticipants += Number(rowData.GMMParticipants || 0);
      columnTotals.MassMediaEvents += Number(rowData.MassMediaEvents || 0);
      columnTotals.MMParticipants += Number(rowData.MMParticipants || 0);

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Branch,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.SDP_en,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.AreaName_en,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Typeoftopicsubject,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.GenderAge,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: Number(rowData.tentoYears || 0),
          t: "n",
          s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" },
        },
        {
          v: Number(rowData.fifteentoYears || 0),
          t: "n",
          s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" },
        },
        {
          v: Number(rowData.twentyfivetoYears || 0),
          t: "n",
          s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" },
        },
        {
          v: Number(rowData.GroupDiscussionsEvents || 0),
          t: "n",
          s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" },
        },
        {
          v: Number(rowData.GDParticipants || 0),
          t: "n",
          s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" },
        },
        {
          v: Number(rowData.GeneralMassEvents || 0),
          t: "n",
          s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" },
        },

        {
          v: Number(rowData.GMMParticipants || 0),
          t: "n",
          s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" },
        },

        {
          v: Number(rowData.MassMediaEvents || 0),
          t: "n",
          s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" },
        },
        {
          v: Number(rowData.MMParticipants || 0),
          t: "n",
          s: { ...baseStyle, alignment: { horizontal: "right" }, numFmt: "0" },
        },
      ];
    });

    // Create totals row
    const totalsRowStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: "E0E0E0" } },
      alignment: { horizontal: "right" },
      numFmt: "0",
    };

    const grandTotal = Object.values(columnTotals).reduce(
      (sum, val) => sum + val,
      0,
    );

    const totalsRow = [
      { v: "", s: totalsRowStyle },
      { v: "", s: totalsRowStyle },
      { v: "", s: totalsRowStyle },

      {
        v: "Total",
        s: { ...totalsRowStyle, alignment: { horizontal: "left" } },
      },
      { v: "", s: totalsRowStyle },
      { v: "", s: totalsRowStyle },
      { v: columnTotals.tentoYears, t: "n", s: totalsRowStyle },
      { v: columnTotals.fifteentoYears, t: "n", s: totalsRowStyle },
      { v: columnTotals.twentyfivetoYears, t: "n", s: totalsRowStyle },
      { v: columnTotals.GroupDiscussionsEvents, t: "n", s: totalsRowStyle },
      { v: columnTotals.GDParticipants, t: "n", s: totalsRowStyle },
      { v: columnTotals.GeneralMassEvents, t: "n", s: totalsRowStyle },

      { v: columnTotals.GMMParticipants, t: "n", s: totalsRowStyle },
      { v: columnTotals.MassMediaEvents, t: "n", s: totalsRowStyle },
      { v: columnTotals.MMParticipants, t: "n", s: totalsRowStyle },
    ];

    // Combine all rows

    const wsData = [
      titleRow,
      dateRangeRow,
      branchRow,
      spacingRow,
      headerRow1,
      headerRow2,
      ...dataRows,
      totalsRow,
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const totalRowIndex = 6 + dataRows.length; // actual row number of Total row

    // ws["!merges"] = [
    //   { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } },
    //   { s: { r: 4, c: 0 }, e: { r: 5, c: 0 } },
    //   { s: { r: 4, c: 1 }, e: { r: 5, c: 1 } },
    //   { s: { r: 4, c: 2 }, e: { r: 5, c: 2 } },
    //   { s: { r: 4, c: 3 }, e: { r: 5, c: 3 } },
    //   { s: { r: 4, c: 4 }, e: { r: 5, c: 4 } },
    //   { s: { r: 4, c: 5 }, e: { r: 4, c: 8 } },
    //   { s: { r: 4, c: 9 }, e: { r: 4, c: 10 } },
    //   { s: { r: 4, c: 11 }, e: { r: 4, c: 12 } },
    //   { s: { r: 4, c: 13 }, e: { r: 4, c: 14 } },
    //   { s: { r: 4, c: 15 }, e: { r: 5, c: 15 } },

    //   // ...dataRows.map((_, index) => ({
    //   //   s: { r: 3 + (index * 3), c: 9 },
    //   //   e: { r: 5 + (index * 3), c: 9 },

    //   // })),

    //   ...dataRows
    //     .filter((row, index) => 6 + index * 3 < totalRowIndex)
    //     .map((_, index) => ({
    //       s: { r: 6 + index * 3, c: 9 },
    //       e: { r: 8 + index * 3, c: 9 },
    //     })),

    //   ...dataRows
    //     .filter((row, index) => 6 + index * 3 < totalRowIndex)
    //     .map((_, index) => ({
    //       s: { r: 3 + index * 3, c: 10 },
    //       e: { r: 5 + index * 3, c: 10 },
    //     })),

    //   ...dataRows
    //     .filter((row, index) => 6 + index * 3 < totalRowIndex)
    //     .map((_, index) => ({
    //       s: { r: 3 + index * 3, c: 11 },
    //       e: { r: 5 + index * 3, c: 11 },
    //     })),

    //   ...dataRows
    //     .filter((row, index) => 6 + index * 3 < totalRowIndex)
    //     .map((_, index) => ({
    //       s: { r: 3 + index * 3, c: 12 },
    //       e: { r: 5 + index * 3, c: 12 },
    //     })),

    //   ...dataRows
    //     .filter((row, index) => 6 + index * 3 < totalRowIndex)
    //     .map((_, index) => ({
    //       s: { r: 3 + index * 3, c: 13 },
    //       e: { r: 5 + index * 3, c: 13 },
    //     })),

    //   ...dataRows
    //     .filter((row, index) => 6 + index * 3 < totalRowIndex)
    //     .map((_, index) => ({
    //       s: { r: 3 + index * 3, c: 14 },
    //       e: { r: 5 + index * 3, c: 14 },
    //     })),
    // ];
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } },
      { s: { r: 4, c: 0 }, e: { r: 5, c: 0 } },
      { s: { r: 4, c: 1 }, e: { r: 5, c: 1 } },
      { s: { r: 4, c: 2 }, e: { r: 5, c: 2 } },
      { s: { r: 4, c: 3 }, e: { r: 5, c: 3 } },
      { s: { r: 4, c: 4 }, e: { r: 5, c: 4 } },
      { s: { r: 4, c: 5 }, e: { r: 4, c: 8 } },
      { s: { r: 4, c: 9 }, e: { r: 4, c: 10 } },
      { s: { r: 4, c: 11 }, e: { r: 4, c: 12 } },
      { s: { r: 4, c: 13 }, e: { r: 4, c: 14 } },
      { s: { r: 4, c: 15 }, e: { r: 5, c: 15 } },

      // For each group of 3 rows (Female/Male/Other), merge cols 9–14
      ...Array.from({ length: Math.floor(dataRows.length / 3) }, (_, groupIndex) => {
        const startRow = 6 + groupIndex * 3;
        const endRow = startRow + 2;
        return [9, 10, 11, 12, 13, 14].map(col => ({
          s: { r: startRow, c: col },
          e: { r: endRow, c: col },
        }));
      }).flat(),
    ];
    // Define consistent column widths for all columns (adjust as needed)
    ws["!cols"] = [
      { width: 8 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 10 },
      { width: 16 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    ws["!rows"] = [
      { hpt: 25 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);
    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Export the Excel file
    XLSX.writeFile(wb, "IEC_Summary_Report.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });
    const logoWidth = 30;
    const logoHeight = 14;
    doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);

    // Ensure iecGDReportHeader is an array of objects with a title property
    // const headers = iecGDReportHeader.map((column) => column.title);
    const headers = [
      { content: "S.No.", rowSpan: 2 },
      { content: "Branch", rowSpan: 2 },
      { content: "Type of topic/ subject", rowSpan: 2 },
      { content: "Interpersonal contact (1-4 persons)", colSpan: 4 },
      { content: "Group discussions (5-20 persons)", colSpan: 2 },
      { content: "General / Mass meetings (21+persons)", colSpan: 2 },
      { content: "Mass media/Supporting activities", colSpan: 2 },
    ];
    const subHeaders = [
      "Gender/Age",
      "10-14 Years",
      "15-24 Years",
      "25+ Years",
      "Events",
      "Participants",
      "Events",
      "Participants",
      "Events",
      "Participants",
    ];
    // Map bindReportMonthlyEvents to the appropriate format for autoTable
    const data = bindIECSummaryData.map((rowData, index) => {
      return [
        index + 1,
        rowData.Branch,
        rowData.Typeoftopicsubject,
        rowData.GenderAge,
        rowData.tentoYears,
        rowData.fifteentoYears,
        rowData.twentyfivetoYears,
        rowData.GroupDiscussionsEvents,
        rowData.GDParticipants,
        rowData.GeneralMassEvents,
        rowData.GMMParticipants,
        rowData.MassMediaEvents,
        rowData.MMParticipants,
      ];
    });

    // Create the table with headers and data
    doc.autoTable({
      head: [headers, subHeaders],
      body: data,
      startY: 30,
      styles: {
        fontSize: 7, // Reduced font size
        lineColor: "black",
        lineWidth: 0.2,
        halign: "center", // Align text to center
        valign: "middle", // Align text vertically in the middle
        cellPadding: 2, // Add padding to cells
        overflow: "linebreak", // Allow text to wrap within cells
      },
      headStyles: {
        fillColor: "#2d2d6e",
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray color for alternate rows
      },
      columnStyles: {
        0: { cellWidth: 10 }, // Index column
        1: { cellWidth: "auto" }, // Auto adjust width
        2: { cellWidth: "auto" }, // Auto adjust width
        3: { cellWidth: "auto" }, // Auto adjust width
        4: { cellWidth: "auto" }, // Auto adjust width
        5: { cellWidth: "auto" }, // Auto adjust width
        6: { cellWidth: "auto" }, // Age
        7: { cellWidth: "auto" }, // Gender
        8: { cellWidth: "auto" }, // Auto adjust width
        9: { cellWidth: "auto" }, // Auto adjust width
        10: { cellWidth: "auto" }, // Auto adjust width
        11: { cellWidth: "auto" }, // Auto adjust width
        12: { cellWidth: "auto" }, // Auto adjust width
        13: { cellWidth: "auto" }, // Auto adjust width
      },
    });

    doc.save("IEC_Summary_Report.pdf");
  };

  const BranchProjectFetchData = async () => {
    try {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };

      const locationResponse = await BindPostAPI([data], "LocationAPI/BindLocation");


      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindBranchProjectDD(locationData);
    } catch (error) { }
  };

  const sdpChange = (updatedOptions) => {
    setArea("");
    setShowTable(false);
    setSDP(updatedOptions);
    setBindAreaDD([]);
    const SDPlabels = getSDPNames(updatedOptions);
    setSDPNamesList(SDPlabels);
  };

  const getSDPNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map((option) => bindSDP?.find((item) => item.value === option)?.label)
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  const brangeChange = (updatedOptions) => {
    setSDP("");
    setShowTable(false);
    setArea("");
    setBindSDP([]);
    setBindAreaDD([]);
    setBranchProject(updatedOptions);
    const branchProjectlabels = getBranchProjectsNames(updatedOptions);
    setBranchProjectNamesList(branchProjectlabels);
  };

  const getBranchProjectsNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map(
        (option) =>
          bindBranchProjectDD?.find((item) => item.value === option)?.label,
      )
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  const areaChange = (updatedOptions) => {
    // setArea("");
    setShowTable(false);
    setArea(updatedOptions);
    const arealabels = getAreaNames(updatedOptions);
    setAreaNamesList(arealabels);
  };

  const getAreaNames = (updatedOptions) => {
    const NameList = updatedOptions
      .map((option) => bindArea?.find((item) => item.value === option)?.label)
      .filter(Boolean); // Remove undefined values if any

    return NameList;
  };

  return (
    <MainLayout pageName="4">

      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />

      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`IEC Summary`}</div>
            </div>
            <div className={mainTable.grid3}>
              {userProfileDatas[0]?.MstOrganizationId == 1 && (
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Branch/Project"
                    filteredOptions={bindBranchProjectDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      branchProject?.length > 0 ? "More Selected" : "Select..."
                    }
                    name="branchProject"
                    selectedOptions={branchProject}
                    classDiv="relative w-full inline-block"
                    onChange={brangeChange}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {branchProjectError && (
                    <span className="text-red-500">{branchProjectError}</span>
                  )}
                </div>
              )}
              {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                userProfileDatas[0]?.MstOrganizationId == 3) && (
                  <InputText
                    inputType="text"
                    title="Branch/Project"
                    classStar="text-red-500"
                    name="schoolName"
                    disabled="true"
                    content={branchName}
                    controlFunc={(e) => setBranchName(e.target.value)}
                  />
                )}
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="SDP"
                  filteredOptions={bindSDP}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={sdp?.length > 0 ? "More Selected" : "Select..."}
                  name="sdp"
                  selectedOptions={sdp}
                  classDiv="relative w-full inline-block"
                  onChange={sdpChange}
                  classLabel={mainTable.labelNoWrap}
                />
                {sdpError && <span className="text-red-500">{sdpError}</span>}
              </div>

              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Area"
                  filteredOptions={bindArea}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={area?.length > 0 ? "More Selected" : "Select..."}
                  name="area"
                  selectedOptions={area}
                  classDiv="relative w-full inline-block"
                  onChange={areaChange}
                  classLabel={mainTable.labelNoWrap}
                />
                {areaError && <span className="text-red-500">{areaError}</span>}
              </div>
            </div>
            <div class={mainTable.grid3}>
              <AutoDropDown
                classStar="text-red-500"
                title="Month"
                options={bindMonthDD}
                placeholder="Select"
                name="fromDate"
                selectedOption={bindMonthDD.find((x) => x.value == fromDate)}
                Class="custom-class"
                tabIndex="1"
                controlFunc={(value, e) => {
                  setFromDate(value.value);
                }}
                controlFuncBlur={() => {
                  if (!fromDate) {
                    setFromDateError("Select From Month");
                  } else {
                    setFromDateError("");
                  }
                }}
                errorMessage={fromDateError}
              />

              <AutoDropDown
                classStar="text-red-500"
                title="Year"
                options={bindYearDD}
                placeholder="Select"
                name="year"
                selectedOption={bindYearDD.find((x) => x.value == year)}
                Class="custom-class"
                tabIndex="1"
                controlFunc={(value, e) => {
                  setYear(value.value);
                }}
                controlFuncBlur={() => {
                  if (!year) {
                    setYearError("Select Year");
                  } else {
                    setYearError("");
                  }
                }}
                errorMessage={yearError}
              />
              {/* <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => {
                  setShowTable(false);
                  setFromDate(e.target.value);
                }}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => {
                  setShowTable(false);

                  setToDate(e.target.value);
                }}
              /> */}
              <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable &&
          (bindIECSummaryData.length > 0 ? (
            <div className=" ">
              <ReportGridPage
                title="INFORMATION, EDUCATION AND COMMUNICATION"
                header={IECSummaryHeader}
                records={bindIECSummaryData}
                handleExport={handleExport}
                handlePDF={downloadPDF}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          ))}
      </div>
    </MainLayout>
  );
};

export default ReportIECSummary;
